import { render, staticRenderFns } from "./InformasiLainnya-Mobile.vue?vue&type=template&id=17de0b5b&scoped=true"
import script from "./InformasiLainnya-Mobile.vue?vue&type=script&lang=js"
export * from "./InformasiLainnya-Mobile.vue?vue&type=script&lang=js"
import style0 from "./InformasiLainnya-Mobile.vue?vue&type=style&index=0&id=17de0b5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17de0b5b",
  null
  
)

export default component.exports